import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { News } from "./News/News";
import { corporateHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { Icon } from "@iconify/react";
import { ChildHeader } from "./ChildHeader/ChildHeader";
import { GrandChildHeader } from "./GrandChildHeader/GrandChildHeader";
import { ParentHeader } from "./ParentHeader/ParentHeader";

export const Navigation = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Parent Header",
      key: "parentHeader",
      children: <ParentHeader/>
    },
    {
      label: "Child Header",
      key: "childHeader",
      children: <ChildHeader/>
    },
    {
      label: "Grand Child Header",
      key: "grandChildHeader",
      children: <GrandChildHeader/>
    },
  ];

  const handleProductManagement=(activeTab:any)=>{
    if(activeTab==='parentHeader'){
      return (<Button
       onClick={() => {
         navigate("/dedicated/corporate/training-academy/navigation/parentHeader/add");
       }}
       icon={<Icon icon={"lucide:plus"} />}
       >
         Add Parent Header
       </Button>)
    } else if(activeTab==='childHeader'){
      return (<Button
       onClick={() => {
         navigate("/dedicated/corporate/training-academy/navigation/childHeader/add");
       }}
       icon={<Icon icon={"lucide:plus"} />}
       >
         Add Child Header
       </Button>)
    } else if(activeTab==='grandChildHeader'){
      return (<Button
       onClick={() => {
         navigate("/dedicated/corporate/training-academy/navigation/grandChildHeader/add");
       }}
       icon={<Icon icon={"lucide:plus"} />}
       >
         Add Grandchild Header
       </Button>)
    } 
  }

  return (
    // <ContentWrapper
    //   title={"Navigation"}
    //   actionItems={handleProductManagement(query.get('subActiveTab'))}
    // >
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    // </ContentWrapper>
  );
};
